const UrlNames = {
  satCourse: "/satCourse",
  chapters: "/chapters",
  topics: "/topics",
  content: "/content",
  videoPlayer: "/videoplayer",
  mockTest: "/mocktest",
  mockInfo: "/mockinfo",
  mockInsturction: "/mockinstruction",
  mockTestReading: "/mocktestreading",
  mockTestMathematics: "/mocktestmathematics",
  bookMark: "/bookmark",
} as const;

export type UrlName = keyof typeof UrlNames;

export default UrlNames;
